const liveSort = (sortParams) => {
    if (!sortParams) {
        return (items) => items;
    }

    const orderBy  = sortParams['orderBy'] ?? 'id';
    const orderDirection = sortParams['orderDirection'] ?? 'asc';
    const sortAs = sortParams['sortAs'] ?? 'text';

    return (items) => {
        return items.sort((a, b) => {
            if (sortAs === 'integer') {
                return compareNumbers(
                    orderDirection.toLowerCase(),
                    parseInt(a[orderBy] ?? 0),
                    parseInt(b[orderBy] ?? 0)
                );
            }

            // if (sortAs === 'text') {
                return compareText(
                    orderDirection.toLowerCase(),
                    (a[orderBy] ?? '').toString(),
                    (b[orderBy] ?? '').toString(),
                );
            // }
        });
    }
}

const compareNumbers = (orderDirection, a, b) => {
    return orderDirection === 'asc' ? a - b : b - a;
}

const compareText = (orderDirection, a, b) => {
    return orderDirection === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
}

export {
    liveSort,
}
